import { z } from 'zod'

export const UI_TRANSITION_CONTEXT = {
  fullMember: 'full_member',
  memberChat: 'member_chat',
  memberChart: 'member_chart',
  memberTasksList: 'member_tasks_list',
} as const

const UI_TRANSITION_CONTEXT_KEYS = Object.values(UI_TRANSITION_CONTEXT) as [string, ...string[]]

export const uiTransitionSchema = z.object({
  context: z.enum(UI_TRANSITION_CONTEXT_KEYS),
  programUuid: z.string(),
  retries: z.number().optional(),
})
